/* eslint-disable */
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { DatePicker } from "@mui/x-date-pickers";
import SearchIcon from "@mui/icons-material/Search";
import { Add } from "@mui/icons-material";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import PrecisionManufacturingOutlinedIcon from "@mui/icons-material/PrecisionManufacturingOutlined";
import { useEffect, useState, useContext } from "react";
import { getCacheData } from "../../services/CacheService";
import { getGestionesAtencion, gcConfirmaAProduccion } from "../../../project/services/GestionAtencionService";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";

const initialSearchData = {
  codigo: "",
  documento: "",
  nombre: "",
  apellido: "",
  sucursal: "",
  usuario: "",
  fechaCreacionDesde: null,
  fechaCreacionHasta: null,
  estadoActual: "todo",
  particularOSocial: "todo",
  tipoArticulo: "",
  codigoArticulo: "",
  estadoGA: "",
};

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todas",
  },
  {
    id: "venta-concretada",
    descripcion: "Venta concretada",
  },
  {
    id: "venta-concretada-cancelada",
    descripcion: "Venta concretada - canceladas",
  },
  {
    id: "venta-concretada-no-cancelada",
    descripcion: "Venta concretada - no canceladas",
  },
  {
    id: "venta-no-concretada",
    descripcion: "Venta no concretada",
  },
  {
    id: "venta-no-concretada-emite-presupuesto",
    descripcion: "Venta no concretada - Con presupuesto",
  },
  {
    id: "venta-no-concretada-no-emite-presupuesto",
    descripcion: "Venta no concretada - Sin presupuesto",
  },
];

const particularOSocialOptions = [
  {
    id: "todo",
    descripcion: "Todas",
  },
  {
    id: "particular",
    descripcion: "Particular",
  },
  {
    id: "obra-social",
    descripcion: "Obra Social",
  },
];

const nameItemsText = "Gestiones de Atención";
//
// ################################################################################
//
const GestionAtencionTable = () => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [gestionesAtencion, setGestionesAtencion] = useState([]);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectableRowsHideCheckboxes, setSelectableRowsHideCheckboxes] = useState(true);
  const [showCobrarButton, setShowCobrarButton] = useState(false);
  const [cantidadGACobrar, setCantidadGACobrar] = useState(0);
  const [gaSelected, setGaSelected] = useState([]);
  const [areas, setAreas] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [idGcConfirmarProduccion, setIdGcConfirmarProduccion] = useState("");
  const [openDialogConfirmaProduccion, setOpenDialogConfirmaProduccion] = useState(false);

  const { hasPermission } = useContext(AuthContext);
  const _crearGestionAtencion = hasPermission("gestion-comercial-c");
  const _editarGestionAtencion = hasPermission("gestion-comercial-e");
  const _cobrarGestionAtencion = hasPermission("gc-cobranza-b");
  const _confirmarProduccionGestionAtencion = hasPermission("anteojo-arreglo-confirma-produccion");

  const tableColumns = [
    {
      field: "codigo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "fecha_creacion",
      headerName: "Fecha creación",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_creacion;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cliente",
      headerName: "Cliente",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.nombre_cliente + " " + params.row.apellido_cliente;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "precio_venta_total",
      headerName: "Total",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.precio_venta_total;
        _val = _val ? _val.toFixed(2) : "";
        return _val;
      },
    },
    {
      field: "pendiente_pago_total",
      headerName: "Saldo",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.pendiente_pago_total.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "particular_osocial",
      headerName: "Tipo",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.particular_osocial === "particular" ? "PARTICULAR" : "O.SOCIAL";
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "concretada_nconcretada",
      headerName: "Estado venta?",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.concretada_nconcretada === "venta-concretada" ? "Concretada" : "No Concretada";
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_corta_area",
      headerName: "Sucursal",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_corta_area;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "usuario",
      headerName: "Vendedor",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.usuario;
        _val = _val ? _val.toLowerCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      width: 170,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {params.row.action_ver === true && (
            <Tooltip title="ver estado">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => {
                  handleClickGA(params.row, "view");
                }}
              >
                <RemoveRedEyeOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.action_editar === true && _editarGestionAtencion && (
            <Tooltip title="editar">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => {
                  handleClickGA(params.row, "update");
                }}

              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.action_cobrar === true && _cobrarGestionAtencion && (
            <Tooltip title="cobrar">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => {
                  cobraGestionAtencion(params.row);
                }}

              >
                <PaidOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.action_confirmar_produccion === true && _confirmarProduccionGestionAtencion && (
            <Tooltip title="confirmar a producción">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => {
                  setIdGcConfirmarProduccion(params.row.id);
                  setOpenDialogConfirmaProduccion(true);
                }}

              >
                <PrecisionManufacturingOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    loadAreas();
    loadUsuarios();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  const loadAreas = async () => {
    const response = await getCacheData('area');
    if (response.ok) {
      const _response = response.data.data.filter(area => area.interno_externo === "interno" && area.actividad === "punto-de-venta");
      setAreas(_response);
      const _id_area = localStorage.getItem("id_area_ventas");
      if (_id_area) {
        setSearchData({
          ...searchData,
          sucursal: _id_area,
        });
      }
    } else {
      setAreas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadUsuarios = async () => {
    const response = await getCacheData('usuario');
    if (response.ok) {
      setUsuarios(response.data.data);
    } else {
      setUsuarios([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const load = async () => {

    const _id_area = localStorage.getItem("id_area_ventas");

    let _params = {
      codigo: searchData.codigo,
      documento: searchData.documento,
      nombre: searchData.nombre,
      apellido: searchData.apellido,
      sucursal: !searchData.sucursal ? _id_area : searchData.sucursal,
      usuario: searchData.usuario,
      fechaCreacionDesde: searchData.fechaCreacionDesde,
      fechaCreacionHasta: searchData.fechaCreacionHasta,
      estadoActual: searchData.estadoActual,
      particularOSocial: searchData.particularOSocial,
      tipoArticulo: "",
      codigoArticulo: "",
      estadoGA: "",
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getGestionesAtencion(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setGaSelected([]);
      setShowCobrarButton(false);
      setCantidadGACobrar(0);
      let _hideCheckboxes = true;

      if (
        searchData.estadoActual === "venta-concretada-no-cancelada" &&
        searchData.particularOSocial === "particular"
      ) {
        // si en los criterios de busqueda el usuario ha seleccionado ver las GAs concretadas en venta
        // y no canceladas, muestro checks para que el usuario pueda elegir cobrar mas de una
        _hideCheckboxes = false;
      }
      setSelectableRowsHideCheckboxes(_hideCheckboxes);
      setGestionesAtencion(response.data.data);
      setTotalRowsCount(response.data?.count || 0);

    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const seleccionarGA = (currentRowsSelected, allRowsSelected, rowsSelected) => {
    // este metodo se dispara cuando el usuario selecciona o deselecciona una fila de la tabla de GAs

    setShowCobrarButton(rowsSelected.length);
    setCantidadGACobrar(rowsSelected.length);
    setGaSelected(rowsSelected);
  };

  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaCreacionDesde = (fecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionDesde: fecha,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaCreacionHasta = (fecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionHasta: fecha,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
    setSelectableRowsHideCheckboxes(true);
    setTotalRowsCount(0);
    setGestionesAtencion([]);
    setShowCobrarButton(false);
    setCantidadGACobrar(0);
    setGaSelected([]);
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    load();
  };
  //
  // ################################################################################
  //
  const handleClickGA = (parRow, parAction) => {
    let _url = "";
    if (parAction === "new") {
      _url = `/gestion-atencion/new/new`;
    } else if (parAction === "update" || parAction === "view") {
      _url = `/gestion-atencion/${parRow.id}/${parAction}`;
    }
    window.open(_url, "_blank");
  };
  //
  // ################################################################################
  //
  const cobraGestionAtencion = (parRow) => {
    let _gaArray = [];
    let _gaObject = {};

    if (parRow !== undefined) {
      // si el usuario esta cobrando una sola ga desde la table de ga

      let _gaObject = {
        id: parRow.id,
      };
      _gaArray.push(_gaObject);
    } else {
      // si el usuario esta cobrando una o mas ga habiendo seleccionado 1 o + y luego click en el boton cobrar

      gaSelected.forEach((item) => {
        _gaObject = {
          id: gestionesAtencion[item].id,
        };
        _gaArray.push(_gaObject);
      });
    }
    const _url = `/gestion-atencion-cobro/${JSON.stringify(_gaArray)}`;
    window.open(_url, "_blank");
  };
  //
  // ################################################################################
  //
  const handleCloseDialogConfirmaProduccion = (parConfirmaProduccion) => {
    parConfirmaProduccion =
      typeof parConfirmaProduccion == "boolean" ? parConfirmaProduccion : false;

    if (parConfirmaProduccion) {
      confirmaAProduccion(idGcConfirmarProduccion);
    }
    setOpenDialogConfirmaProduccion(false);
  };
  //
  // ################################################################################
  //
  const confirmaAProduccion = async (parIdGestionAtencion) => {

    setIsDoingSomething(true);
    const response = await gcConfirmaAProduccion(parIdGestionAtencion, "", "");
    setIsDoingSomething(false);

    if (response.ok) {
      load();
    }

    setMessage({
      severity: response.messageSeverity,
      messageText: response.messageText,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="cristal" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigo"
                  label="Código"
                  variant="outlined"
                  size="small"
                  name="codigo"
                  value={searchData.codigo}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="documento"
                  label="Documento"
                  variant="outlined"
                  size="small"
                  name="documento"
                  value={searchData.documento}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="nombre"
                  label="Nombre"
                  variant="outlined"
                  size="small"
                  name="nombre"
                  value={searchData.nombre}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="apellido"
                  label="Apellido"
                  variant="outlined"
                  size="small"
                  name="apellido"
                  value={searchData.apellido}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel
                    id="sucursal-select-label"
                    sx={{
                      transform: "translate(15px, 10px) scale(1)",
                      "&.MuiInputLabel-shrink": {
                        transform: "translate(14px, -8px) scale(0.75)", // Ajuste para cuando el label se reduce
                      },
                    }}
                  >
                    Sucursal
                  </InputLabel>
                  <Select
                    labelId="area-select-label"
                    id="area-select"
                    name="sucursal"
                    value={searchData.sucursal}
                    label="Sucursal"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {areas.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(14px, 9px) scale(1)",
                    },
                    "& .MuiInputBase-root": {
                      paddingRight: "10px",
                    },
                    "& .MuiInputLabel-shrink": {
                      transform: "translate(14px, -8px) scale(0.75)",
                    },
                  }}
                  id="fechaCreacionDesde"
                  label="Desde fecha"
                  variant="outlined"
                  name="fechaCreacionDesde"
                  value={searchData.fechaCreacionDesde}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(newValue) =>
                    handleChangeFechaCreacionDesde(newValue)
                  }
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      sx: { width: "100%" },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(14px, 9px) scale(1)",
                    },
                    "& .MuiInputBase-root": {
                      paddingRight: "10px",
                    },
                    "& .MuiInputLabel-shrink": {
                      transform: "translate(14px, -8px) scale(0.75)",
                    },
                  }}
                  id="fechaCreacionHasta"
                  label="Hasta fecha"
                  variant="outlined"
                  name="fechaCreacionHasta"
                  value={searchData.fechaCreacionHasta}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(newValue) =>
                    handleChangeFechaCreacionHasta(newValue)
                  }
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      sx: { width: "100%" },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="estado-actual-select-label">Estado actual</InputLabel>
                  <Select
                    labelId="estado-actual-select-label"
                    id="estado-actual-select"
                    name="estadoActual"
                    value={searchData.estadoActual}
                    label="Estado actual"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="particular-osocial-select-label">
                    Tipo de Gestión de Atención
                  </InputLabel>
                  <Select
                    labelId="particular-osocial-select-label"
                    id="particular-osocial-select"
                    name="particularOSocial"
                    value={searchData.particularOSocial}
                    label="Tipo de Gestión de Atención"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {particularOSocialOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel
                    id="usuario-select-label"
                    sx={{
                      transform: "translate(15px, 10px) scale(1)",
                      "&.MuiInputLabel-shrink": {
                        transform: "translate(14px, -8px) scale(0.75)", // Ajuste para cuando el label se reduce
                      },
                    }}
                  >
                    Usuario
                  </InputLabel>
                  <Select
                    labelId="usuario-select-label"
                    id="usuario-select"
                    name="usuario"
                    value={searchData.usuario}
                    label="Vendedor"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {usuarios.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.nombre}, {item.apellido}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mx: 1, mb: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>

              {_crearGestionAtencion && (
                <Grid item xs={12} md={12} lg={1}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Tooltip title="nueva gestión de atención">
                      <Button
                        fullWidth
                        className="btn-add"
                        variant="contained"
                        size="small"
                        onClick={() => handleClickGA(null, "new")}
                        startIcon={<Add />}
                      // disabled={!_crearGestionAtencion}
                      >
                        Nueva GA
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              )}

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar filtros de búsqueda">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              {showCobrarButton ? (
                <>
                  <Grid item xs={12} md={12} lg={1}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Tooltip title="cobrar GA">
                        <Button
                          fullWidth
                          sx={{ mt: 2 }}
                          variant="outlined"
                          size="small"
                          onClick={() => cobraGestionAtencion()}
                        // startIcon={<CleaningServicesIcon />}
                        >
                          Cobrar ({cantidadGACobrar})
                        </Button>
                      </Tooltip>
                    </Box>
                  </Grid>
                </>
              ) : null}
            </Grid>
          </Box>
        </Paper>

        <DataGrid
          rows={gestionesAtencion}
          columns={tableColumns}
          {...tableOptions}
        />
      </Paper>

      <Dialog
        open={openDialogConfirmaProduccion}
        onClose={handleCloseDialogConfirmaProduccion}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmación a Producción"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Estás seguro que querés confirmar el envío a producción de todos los Anteojos y Arreglos
            de esta Gestión Comercial?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseDialogConfirmaProduccion(true)}>
            Confirmar a Producción
          </Button>
          <Button onClick={() => handleCloseDialogConfirmaProduccion(false)} autoFocus>
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default GestionAtencionTable;